import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { AuthService } from "app/core/auth/service/auth.service";
import { AuthGuard } from "app/core/guards/auth.guard";
import { AuthInterceptor } from "app/core/interceptors/auth.interceptor";
import { UcbInterceptor } from "app/core/interceptors/ucb-interceptor";
import { ThemeModule } from "app/core/theme/theme.module";
import { VOICE_API_PATHS } from "app/shared/constants/voice-api-paths";
import { NGXLogger } from "ngx-logger";

@NgModule({
  imports: [ThemeModule],
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        AuthGuard,
        AuthService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          deps: [AuthService, NGXLogger],
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: UcbInterceptor,
          deps: [VOICE_API_PATHS],
          multi: true,
        },
      ],
    };
  }
}
